import { api } from "./config";

export async function GetAllStations() {
  try {
    const response = await api().get("/station/all");
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetAllStationsAdmin() {
  try {
    const response = await api().get("/station/admin/all");
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function StoreStation(data) {
  try {
    const response = await api().post("/station/store", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function PatchStation(data) {
  try {
    const response = await api().patch("/station/patch", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function SendStationDailyReportTest(id) {
  try {
    const response = await api().post("/station/daily-report/test", { id });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function DeleteStation(id) {
  try {
    const response = await api().delete(`/station/delete/${id}`);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetStationList() {
  try {
    const response = await api().get("/station/list");
    
    // Return the backend response as-is for backward compatibility
    return response.data;
  } catch (error) {
    console.error("GetStationList error:", error);
    
    // Handle error responses - return backend error format for consistency
    if (error.response && error.response.data) {
      return error.response.data; // Backend returns { success: false, message: "..." }
    }
    
    // Handle network or other errors
    return { 
      success: false, 
      message: "Network error" 
    };
  }
}

export async function GetFinalStationList() {
  try {
    const response = await api().get("/station/final");
    
    // Return the backend response as-is for backward compatibility
    return response.data;
  } catch (error) {
    console.error("GetFinalStationList error:", error);
    
    // Handle error responses - return backend error format for consistency
    if (error.response && error.response.data) {
      return error.response.data; // Backend returns { success: false, message: "..." }
    }
    
    // Handle network or other errors
    return { 
      success: false, 
      message: "Network error" 
    };
  }
}

export async function GetStationDetailById(id) {
  try {
    const response = await api().get("station/detail", {
      params: {
        id: id,
      },
    });
    
    // Return the backend response as-is for backward compatibility
    return response.data;
  } catch (error) {
    console.error("GetStationDetailById error:", error);
    
    // Handle error responses - return backend error format for consistency
    if (error.response && error.response.data) {
      return error.response.data; // Backend returns { success: false, message: "..." }
    }
    
    // Handle network or other errors
    return { 
      success: false, 
      message: "Network error" 
    };
  }
}